export default "__VITE_ASSET__CZkXmBS2__"